import React, { useEffect, useState, useCallback } from 'react'
import ProfilePicture from '../../components/ProfilePicture/ProfilePicture'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useSearchParams, useParams, useLocation } from 'react-router-dom'
import { fetchUserById, fetchSubscribe, getFilteredCreationsOfUser, setViewUser, fetchUserCreations, fetchUserSubscribers, fetchUserSubscriptions } from '../../Reducers/actions/creationsActions'
import { fetchNewsByCreator } from '../../Reducers/actions/newsActions'
import MenuProfile from '../../components/MenuProfile/MenuProfile'
import FilterBar from '../../components/FilterBar/FilterBar'
// import CommentSection from '../../components/CommentSection/CommentSection'
import ViewNetworksSheet from '../../components/ViewNetworksSheet/ViewNetworksSheet'
import { createChat } from '../../Reducers/actions/chatActions'
import { setTopNavbar } from '../../Reducers/actions/navbarActions'
import ContributionSection from '../../components/ContributionSection/ContributionSection'
import ContributionSuccess from '../../components/ContributionSection/ContributionSuccess'
import { getChats, setCurrentChat } from '../../Reducers/actions/chatActions'
import { USER_ROLES } from '../../constants/globals'
import SEOHead from '../../components/SEO/SEOHead'
import Icon from '../../components/Icon/Icon'
import "./UserProfile.scss"
import AboutCreator from '../../components/AboutCreator/AboutCreator'
import BioPreview from '../../components/BioPreview/BioPreview'
import CreationCardV2 from '../../components/ProfileCreations/CreationCardV2'
import NewsItemProfile from '../../components/NewsItemProfile/NewsItemProfile'
import ReportCreationSheet from '../../components/ReportCreationSheet/ReportCreationSheet'
import Stats from '../../components/Stats/Stats'
import { stopScrolling } from '../../Reducers/actions/navigationActions'
import MetaTags from '../../components/MetaTags/MetaTags'
import { getOGImageUrl } from '../../../helpers/getOGImageUrl'
import { getUserDisplayName } from '../../../helpers/userDisplayName'
import Unsubscribe from '../../components/Unsubscribe/Unsubscribe'
import Skeleton from '../../components/Skeleton/Skeleton'
import { useSoftwall } from '../SoftWall/SoftWall'
import { useAutoContributePrompt } from '../../hooks/useAutoContributePrompt'
import { usePullToRefresh } from '../../../hooks/usePullToRefresh'
import { cachingService } from '../../../helpers/cache'
import {
  getProfileShareUrl,
  isProfileUuid,
  normalizeProfileHandle,
} from '../../../helpers/profilePaths'

function getProfileEmptyStateDisplayName(user) {
    const first = String(user?.firstName ?? '').trim()
    if (first) return first
    const username = String(user?.userName ?? '').trim()
    if (username) return username
    return 'This creator'
}

const ProfileCreationsUser = ({ user, creations, handleViewCreation, viewuser_loading }) => {

    const [viewAll, setViewAll] = useState(false)
    return (
        
        <div className='mycreations-container'>
            {/* <div className="my-creations-tabs">
                <FilterBar />
            </div> */}
            {creations && creations.length > 0 ? (
                <div className='creations-wrapper'>
                    {creations.slice(0, viewAll ? creations.length : 6).map(creation => <CreationCardV2 key={creation.creation_id} creation={{ ...creation, users: user }} handleViewCreation={handleViewCreation} />)}
                </div>
            ) : <div className={`gap-8 ${viewuser_loading ? 'creations-wrapper' : 'creations-wrapper-empty'}`}>
                {viewuser_loading ? [1, 2, 3, 4].map(creation => (
                    <Skeleton key={creation} width='175px' height='140px' />
                )) : <div className='empty-state w-full d-flex f-column aic jcc' >
                    <p className='fg-dark fs-sm2 fw-bold mt-24 mb-8 ta-center w-full'>{"No creations yet"}</p>
                    <p className='fg-grey fs-regular fw-medium mt-0 ta-center w-full'>{`${getProfileEmptyStateDisplayName(user)}'s creations will appear here`}</p>
                </div>}
            </div>
            }

            {!viewAll && creations?.length > 6 && <div className='d-flex aic jcc w-full mb-12'>
                <button className="btn red-outline-btn btn-sm fs-tiny mt-24 " onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setViewAll(true)
                }}
                >VIEW ALL</button>
            </div>}
        </div>
    )
}

const ProfileNewsUser = ({ viewuser_loading, user }) => {

    const { news } = useSelector(state => ({
        news: state.news.items
    }))

    const [viewAll, setViewAll] = useState(false)

    // Sort news by recency (most recent first)
    const sortedNews = [...(news || [])].sort((a, b) => {
        const dateA = new Date(a.created_at || a.updated_at || 0);
        const dateB = new Date(b.created_at || b.updated_at || 0);
        return dateB - dateA;
    });

    return (
        <div className='news-container p-16'>
            {sortedNews && sortedNews.length > 0 ? (
                <>
                    <div className='creations-wrapper'>
                        {sortedNews.slice(0, viewAll ? sortedNews.length : 6).map(news => (
                            <NewsItemProfile key={news.id} news={news} />
                        ))}
                    </div>
                    {!viewAll && sortedNews?.length > 6 && <div className='d-flex aic jcc w-full mb-24'>
                        <button className="btn red-outline-btn btn-sm fs-tiny mt-24" onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setViewAll(true)
                        }}
                        >VIEW ALL</button>
                    </div>}
                </>
            ) : (
                <div className='gap-8 creations-wrapper-empty'>
                    {viewuser_loading ? [1, 2, 3, 4].map(news => (
                        <Skeleton key={news} width='175px' height='140px' />
                    )) : <div className='empty-state w-full d-flex f-column aic jcc' >
                        <p className='fg-dark fs-sm2 fw-bold mt-24 mb-8 ta-center w-full'>{"No news yet"}</p>
                        <p className='fg-grey fs-regular fw-medium mt-0 ta-center w-full'>{`${getProfileEmptyStateDisplayName(user)}'s news will appear here`}</p>
                    </div>}
                </div>
            )}
        </div>
    )
}

const MENU_ITEMS = [
    {
        name: 'creation',
        label: 'Creations',
        render: (props) => <ProfileCreationsUser {...props} />
    },
    {
        name: 'news',
        label: 'News',
        render: (props) => <ProfileNewsUser {...props} />
    }
]


const UserProfile = ({ user_id: propUserId, userData: propUserData }) => {

    const { user, creations, auth_user_id, viewuser_loading, auth_user, loadingSubscribers, loadingSubscriptions } = useSelector((state) => ({
        user: state.creation.view_user,
        creations: getFilteredCreationsOfUser(state),
        auth_user_id: state.auth.user?.user_id,
        viewuser_loading: state.creation.viewuser_loading,
        auth_user: state.auth.user,
        loadingSubscribers: state.creation.loadingSubscribers,
        loadingSubscriptions: state.creation.loadingSubscriptions
    }))
    const navigate = useNavigate()
    const location = useLocation()

    const [searchParams] = useSearchParams()
    const { profile_id: paramProfileId, username: usernameParam } = useParams()
    const [selected, setSelected] = useState(MENU_ITEMS[0])
    const [showNetworks, setShowNetworks] = useState(false)
    const shouldOpenContribute = searchParams.get('open') === 'contribute'
    const [showContribution, setShowContribution] = useState(false)
    const [showSuccessContribution, setShowSuccessContribution] = useState(searchParams.get('success') === 'true')
    const [loadingCreateChat, setLoadingCreateChat] = useState(false)
    const [showFullBio, setShowFullBio] = useState(false)
    const [openMenu, setOpenMenu] = useState(false)
    const [showReport, setShowReport] = useState(false)
    const [showStats, setShowStats] = useState(false)
    const [showUnsubscribe, setShowUnsubscribe] = useState(false)
    const [firstLoad, setFirstLoad] = useState(false)

    const [isSubscribed, setIsSubscribed] = useState(false)
    const [subscribersLoaded, setSubscribersLoaded] = useState(false)
    
    // Route segment: UUID (/profiles/...), handle (/username), or legacy query
    const routeProfileKey = propUserId || usernameParam || paramProfileId || searchParams.get('user_id')
    /** Resolved UUID for API calls that require it (after profile load or when URL is already a UUID). */
    const resolvedUserId = user?.user_id ?? (isProfileUuid(routeProfileKey) ? routeProfileKey : null)
    const dispatch = useDispatch()

    // Pull-to-refresh handler
    const handleRefresh = useCallback(async () => {
        if (!resolvedUserId || resolvedUserId === auth_user_id) return;

        try {
            // Clear cache to force fresh fetch
            cachingService.invalidate([`/api/profile/${resolvedUserId}?include_creations=true&include_news=true&include_subscribers=true&include_subscriptions=true`], true);
            cachingService.invalidate([`/api/creations/${resolvedUserId}?page=1&pageSize=20`], true);
            cachingService.invalidate([`/api/news/${resolvedUserId}`], true);

            // Fetch user data with creations, news, subscribers, and subscriptions
            await Promise.all([
                dispatch(fetchUserById(resolvedUserId, true, true, true, true, false)),
                dispatch(fetchUserCreations(resolvedUserId, 1, 20)),
                dispatch(fetchNewsByCreator(resolvedUserId))
            ]);
        } catch (error) {
            console.error('Error refreshing user profile:', error);
        }
    }, [dispatch, resolvedUserId, auth_user_id]);

    // Pull-to-refresh hook
    const { containerRef, isRefreshing, pullDistance, pullProgress, shouldTrigger, shouldShowIndicator } = usePullToRefresh(
        handleRefresh,
        { 
            threshold: 80, 
            disabled: viewuser_loading || !firstLoad || !routeProfileKey || resolvedUserId === auth_user_id
        }
    );
    
    useEffect(() => {
        // If subscribers are not loaded yet and we need to check subscription status, fetch them
        if (user && resolvedUserId && auth_user_id && !subscribersLoaded && user.subscribers === undefined) {
            setSubscribersLoaded(true)
            dispatch(fetchUserSubscribers(resolvedUserId))
        }
        
        // Update subscription status when subscribers are loaded
        if (user?.subscribers && Array.isArray(user.subscribers) && auth_user_id) {
            const subscribed = user.subscribers.some(sub => sub.user_id === auth_user_id);
            setIsSubscribed(subscribed);
        } else if (user?.subscribers === undefined && auth_user_id) {
            // Reset subscription status if subscribers are not loaded
            setIsSubscribed(false);
        }
    }, [user?.subscribers, auth_user_id, resolvedUserId, subscribersLoaded, dispatch]);

    useEffect(() => {
        if (propUserId && propUserId === auth_user_id) {
            navigate('/profile')
            return
        }
        if (paramProfileId && paramProfileId === auth_user_id) {
            navigate('/profile')
            return
        }
        if (
            usernameParam &&
            auth_user?.userName &&
            normalizeProfileHandle(usernameParam) === normalizeProfileHandle(auth_user.userName)
        ) {
            navigate('/profile')
            return
        }
        if (routeProfileKey) {
            // Fetch initial profile with subscribers and subscriptions included for profile screen
            // Note: Counts (subscribers_number, subscriptions_number) should always be included in core data
            dispatch(fetchUserById(routeProfileKey, true, true, true, true, false))
            setShowStats(false)
            dispatch({ type: 'STOP_SCROLLING', payload: false })
        } else {
            setFirstLoad(true);
        }

        dispatch(setTopNavbar({
            title: ' ',
            showBackArrow: true
        }))

        // Scroll to top when component mounts or profile route changes
        window.scrollTo(0, 0)

        return () => {
            dispatch(setViewUser(null))
        }
    }, [dispatch, routeProfileKey, paramProfileId, usernameParam, propUserId, auth_user_id, auth_user?.userName, navigate])

    // Canonical public URL: replace /profiles/{uuid} with /handle when we have a username
    useEffect(() => {
        if (viewuser_loading || !user?.userName) return
        const handle = String(user.userName).replace(/^@/, '').trim()
        if (!handle) return
        if (
            paramProfileId &&
            isProfileUuid(paramProfileId) &&
            location.pathname.startsWith('/profiles/')
        ) {
            navigate(`/${encodeURIComponent(handle)}`, { replace: true })
        }
    }, [viewuser_loading, user?.userName, paramProfileId, navigate, location.pathname])
    
    // Note: Counts should always be returned by backend in the initial response
    // If they're missing (undefined), we fetch them. But if backend returns 0 incorrectly,
    // that's a backend issue that needs to be fixed.

    /** Show Contribute CTA for creator or admin (admin can also be a creator). */
    const isCreatorProfile =
        user?.role === USER_ROLES.creator || user?.role === USER_ROLES.admin;

    // Auto-open contribute modal if open=contribute parameter is present (only for creators)
    useEffect(() => {
        if (shouldOpenContribute && user && isCreatorProfile && !viewuser_loading && !showContribution) {
            // Small delay to ensure the page is fully rendered
            const timer = setTimeout(() => {
                setShowContribution(true);
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [shouldOpenContribute, user, isCreatorProfile, viewuser_loading, showContribution]);

    useEffect(() => {
        const handleResumeContribution = (event) => {
            const pendingIntent = event?.detail;
            if (pendingIntent?.source !== 'contribute') return;
            const intentCreatorId = pendingIntent?.creation?.creator_id;
            if (
                intentCreatorId &&
                user?.user_id &&
                String(intentCreatorId) !== String(user.user_id)
            ) {
                return;
            }
            setShowContribution(true);
        };
        window.addEventListener('hyk:resume-contribution', handleResumeContribution);
        return () => window.removeEventListener('hyk:resume-contribution', handleResumeContribution);
    }, [user?.user_id]);

    const sw = useSoftwall();
    const autoContributePrompt = useAutoContributePrompt(auth_user_id, resolvedUserId, showContribution);
    const handleViewCreation = (creation) => {
        navigate(`/creations/${creation.creation_id}`)
    }

    const handleSubscribeUnsubscribe = (subscribed_to_id, subscribe = true,) => {
        if (!sw.requireAuth("Subscribe to Creator", "Sign up or log in to subscribe to this creator")) {
            return;
        }
        // If user is subscribed and clicking to unsubscribe, show confirmation
        if (!subscribe) {
            setShowUnsubscribe(true);
            return;
        }

        setIsSubscribed(true)
        dispatch({ type: 'SUBSCRIBE_SUCCESS', payload: { subscribe, subscriber_id: auth_user_id, subscribed_to_id, user: auth_user } })

        // HYK-1109: on a real (non-optimistic) new-subscribe success, auto-open the Contribute
        // sheet pre-targeted to this artist. Never gates or blocks the subscribe action itself.
        const subscribeAttempt = autoContributePrompt.beginSubscribeAttempt();
        dispatch(fetchSubscribe(subscribed_to_id, subscribe)).then(({ success, alreadySubscribed }) => {
            if (autoContributePrompt.evaluate(subscribed_to_id, { success, eligible: isCreatorProfile && !alreadySubscribed, startedAtGeneration: subscribeAttempt })) {
                setShowContribution(true);
            }
        })
    }

    const handleConfirmUnsubscribe = () => {
        // HYK-1109: invalidate any pending subscribe attempt so a stale success can't reopen
        // the Contribute sheet for the creator we just unsubscribed from.
        autoContributePrompt.cancel();
        dispatch(fetchSubscribe(resolvedUserId, false))
        // Ensure user object has user_id for the reducer
        const userPayload = user ? { ...user, user_id: resolvedUserId } : { user_id: resolvedUserId };
        dispatch({ type: 'SUBSCRIBE_SUCCESS', payload: { subscribe: false, subscriber_id: auth_user_id, subscribed_to_id: resolvedUserId, user: userPayload } })
        setShowUnsubscribe(false);
    }

    const handleOpenContribute = () => {
        if (isCreatorProfile) {
            setShowContribution(true);
        }
    }

    const handleCreateChat = () => {
        if (!sw.requireAuth("Message Creator", "Sign up or log in to message this creator")) {
            return;
        }
        setLoadingCreateChat(true)
        dispatch(createChat({
            user1_id: auth_user_id,
            user2_id: user?.user_id
        })).then(({ response }) => {
            if (response?.data?.id) {
                dispatch(setCurrentChat(response.data));
                dispatch(getChats());
                navigate(`/chat?chat_id=${response.data.id}`);
            } else {
                navigate('/conversations');
            }
        });
    };

    const handleNativeShare = async () => {
        if (navigator.share) {
            try {
                const authorName = getUserDisplayName(user);
                const authorUsername = user?.userName
                    ? (user.userName.startsWith('@') ? user.userName : `@${user.userName}`)
                    : '';

                const shareTitle = `Check out ${authorUsername ? authorUsername : authorName}'s profile`;

                await navigator.share({
                    title: shareTitle,
                    url: getProfileShareUrl(user),
                });
            } catch (err) {
                console.error("Error sharing:", err);
            }
        } else {
            alert("Sharing is not supported on this device.");
        }
    }


    const reported = !(!user?.user_report || user?.user_report?.status === 'rejected')

    const handleShowStats = (value) => {
        if (!sw.requireAuth("View Creator Stats", "Sign up or log in to view this creator's stats")) {
            return;
        }
        if (user && resolvedUserId) {
            setShowStats(value)
            dispatch(stopScrolling(!!value))
            
            // Fetch subscribers/subscriptions on demand when stats are opened
            if (value === 1 && user.subscribers === undefined) {
                // Stats tab 1 is subscribers
                dispatch(fetchUserSubscribers(resolvedUserId))
            } else if (value === 2 && user.subscriptions === undefined) {
                // Stats tab 2 is subscriptions
                dispatch(fetchUserSubscriptions(resolvedUserId))
            }
        }
    }
    return (
        <div className={`cont ${showStats ? 'stats-shown' : ''}`} onClick={() => setOpenMenu(false)} ref={containerRef}>
            {/* Pull-to-refresh indicator */}
            {(shouldShowIndicator || isRefreshing || shouldTrigger) && (
                <div 
                    className="pull-to-refresh-indicator"
                    style={{
                        transform: `translateY(${Math.min(pullDistance, 1)}px)`,
                        opacity: Math.min(pullProgress, 1)
                    }}
                >
                    <div className="pull-to-refresh-spinner">
                        {isRefreshing ? (
                            <div className="spinner" />
                        ) : (
                            <Icon 
                                alias="chevron-down" 
                                width={24} 
                                color="#FF3232"
                                style={{
                                    transform: `rotate(${shouldTrigger ? 180 : 0}deg)`,
                                    transition: 'transform 0.2s ease'
                                }}
                            />
                        )}
                    </div>
                    <p className="pull-to-refresh-text">
                        {isRefreshing ? 'Refreshing...' : shouldTrigger ? 'Release to refresh' : 'Pull to refresh'}
                    </p>
                </div>
            )}
            
            {/* <SEOHead {...generateSEOData()} /> */}
            {showContribution && <ContributionSection
                creation={{
                    creation_id: null,
                    title: `Creator ${user?.userName}`,
                    description: "Contribution to a creator",
                    creator_id: user?.user_id,
                    thumbnail_url: user?.profilePicture,
                    users: user
                }}
                onClose={() => {
                    autoContributePrompt.handleClose();
                    setShowContribution(false);
                    // Remove the open=contribute parameter from URL when modal is closed
                    if (shouldOpenContribute) {
                        const newSearchParams = new URLSearchParams(searchParams);
                        newSearchParams.delete('open');
                        const newUrl = newSearchParams.toString() 
                            ? `${window.location.pathname}?${newSearchParams.toString()}` 
                            : window.location.pathname;
                        navigate(newUrl, { replace: true });
                    }
                }}
            />}
            {showSuccessContribution && <ContributionSuccess onClose={() => {
                setShowSuccessContribution(false)
                searchParams.delete("success")
                navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
            }}
            />}
            {showNetworks && <ViewNetworksSheet
                instagram={user?.instagram}
                facebook={user?.facebook}
                twitter={user?.twitter}
                youtube={user?.youtube}
                onClose={() => setShowNetworks(false)}
            />}
            {showStats && <Stats user={user} onClose={() => { handleShowStats(null) }} index={showStats} onContribute={handleOpenContribute} />}
            {showFullBio && <AboutCreator user={user} onClose={() => setShowFullBio(false)} />}
            {showReport && <ReportCreationSheet onClose={() => setShowReport(false)} creation_id={user?.user_id} type="user" />}
            {showUnsubscribe && <Unsubscribe user={user} onClose={() => setShowUnsubscribe(false)} onSubmit={handleConfirmUnsubscribe} />}
            <MetaTags
                title={`${user?.userName || getUserDisplayName(user)} - HYK Creator Profile`}
                description={user?.bio || "Check out this creator's profile on HYK."}
                image={getOGImageUrl('profile', {
                  title: `${user?.userName || getUserDisplayName(user)}`,
                  author: user?.userName || getUserDisplayName(user) || '',
                  image: user?.profilePicture || '',
                  description: user?.bio || '',
                  id: user?.user_id || ''
                })}
                url={getProfileShareUrl(user)}
                type="profile"
            />
            <div className='d-flex aic px-16 py-24 profile-header'>
                <Icon alias={"chevron-left"} stroke={"#0A0F1E"} color="#0A0F1E" width={24} onClick={() => navigate(-1)} />
                <p className='fs-sm2 fg-dark fw-bold tt-uppercase ml-12'>{(user?.userName || getUserDisplayName(user)).toUpperCase()}</p>
                <span className="actions ml-auto d-flex aic">
                    <span className="icon-container" onClick={() => setShowNetworks(true)}>
                        <Icon alias={"navigation"} color="#FF3232" width={16} height={16} />
                    </span>
                    <span className="icon-container ml-16 c-pointer" onClick={handleNativeShare}>
                        <Icon alias={"share"} stroke="#FF3232" color='none' width={20} height={20} />
                    </span>
                    <span className="icon-container d-flex p-relative ml-16">
                        <Icon alias={"three_dots"} strokeWidth={2} stroke="#FF3232" width={24} onClick={(e) => { e.stopPropagation(); setOpenMenu(!openMenu) }} />
                        {openMenu && (
                            <div className="news-menu-dropdown" onClick={() => setOpenMenu(false)}>
                                <div className="news-menu-content">
                                    <div className="news-menu-item" onClick={() => setShowReport(true)}>
                                        <span className={`${reported ? "fg-grey7" : "fg-black"}`}>{reported ? "Reported" : "Report"}</span>

                                        <Icon alias={"report_v2"} stroke={reported ? "#777" : "#0A0F1E"} color='none' width={20} />
                                    </div>

                                </div>
                            </div>
                        )}
                    </span>
                </span>
            </div>
            <div className="d-flex aic mx-16 mb-16">
                <div style={{ minWidth: '72px', minHeight: '72px' }}>
                    {viewuser_loading ? <Skeleton height={72} width={72} borderRadius='72px' /> : <ProfilePicture
                        imgUrl={user?.profilePicture}
                        no_edit={true}
                        width={72}
                        height={72}
                        zoomEnable={true}
                    />}
                </div>
                <div className="ml-16">
                    {viewuser_loading ?
                        <Skeleton width='100px' height='12px' className={" mt-0 mb-8"} /> :
                        <p className='fg-dark fw-bold mt-0 mb-8'>{getUserDisplayName(user) || user?.userName || ''}
                        </p>
                    }
                    <div className="d-flex aic">
                        <div className="d-flex f-column fg-dark" onClick={() => handleShowStats(1)}>
                            {viewuser_loading || (user?.subscribers_number === undefined && loadingSubscribers) ?
                                <Skeleton height='20px' width='20px' />
                                : <p className="fw-bold">{user?.subscribers_number ?? 0}</p>}
                            <p className="fs-tiny fw-medium tt-uppercase">Subscribers</p>
                        </div>
                        <div className="d-flex f-column fg-dark ml-16" onClick={() => handleShowStats(2)}>
                            {viewuser_loading || (user?.subscriptions_number === undefined && loadingSubscriptions) ?
                                <Skeleton height='20px' width='20px' />
                                : <p className="fw-bold">{user?.subscriptions_number ?? 0}</p>}
                            <p className="fs-tiny fw-medium tt-uppercase">Subscriptions</p>
                        </div>
                        <div className="d-flex f-column fg-dark ml-16" onClick={() => handleShowStats(4)}>
                            {viewuser_loading ?
                                <Skeleton height='20px' width='20px' />
                                : <p className="fw-bold">{user?.nbContributions ?? 0}</p>}
                            <p className="fs-tiny fw-medium tt-uppercase">Contributions</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mx-16 mb-16 bio">
                <div className='my-0 fs-real fw-medium fg-black bio-text-wrap'>
                    {viewuser_loading ?
                        <Skeleton height='16px' width='300px' />
                        : <BioPreview text={user?.bio} onMore={() => setShowFullBio(true)} />}

                </div>
            </div>

            {viewuser_loading ?
                <div className={`mb-16 mx-16 d-flex jcc`}>
                    <Skeleton height='32px' width='50%' />
                    <Skeleton height='32px' width='50%' />

                </div>
                : <div className={`mb-16 mx-16 d-flex jcc`}>
                    <button
                        className={`btn ${!isSubscribed ? 'red-btn' : 'red-outline-btn'} btn-sm fs-tiny fw-extra-bold rounded-xl btn-full`}
                        onClick={() => handleSubscribeUnsubscribe(user?.user_id, !isSubscribed, auth_user)}
                    >
                        {isSubscribed ? 'Subscribed' : 'Subscribe'}
                    </button>

                    <button className='btn red-outline-btn btn-sm fs-tiny rounded-xl btn-full fw-extra-bold ml-8'
                        onClick={handleCreateChat}
                    >
                        {loadingCreateChat ? <div className="loading-dots loading-dots-red">
                            <div className="dot"></div>
                            <div className="dot"></div>
                            <div className="dot"></div>
                        </div> : 'Message'}
                    </button>
                </div>
            }
            {isCreatorProfile && (
                <div className='contribute d-flex aic mx-16 px-16 mb-24'>
                    {viewuser_loading ?
                        <Skeleton height='16px' width='160px' />
                        :
                        !user?.nbContributors ?
                            <span className='fg-dark fw-medium'>Be the first contributor</span>
                            : <span className='fg-dark fw-medium' onClick={() => handleShowStats(3)}><span className='fw-bold'>{user.nbContributors || 0}</span>{" "}Contributors</span>
                    }

                    <button onClick={handleOpenContribute} className="contribute-btn btn-sm btn-xs red-outline-btn d-flex aic ml-auto fs-tiny fw-medium">
                        <Icon alias={"credit_card"} color="#FF3232" stroke={'#FF3232'} width={16} className={'mr-4'} />
                        <span className='fs-tiny fw-extra-bold'>Contribute</span>
                    </button>
                </div>
            )}
            {/* <div className='d-flex f-column aic mt-32 pt-40'>
                <ProfilePicture
                    imgUrl={user?.profilePicture}
                    no_edit={true}
                    width={72}
                    height={72}
                />
                <div className='ta-center mb-24'>
                    <p className='fg-black fw-medium mt-8 mb-0'>{(user?.userName ? (user.userName.startsWith('@') ? user.userName : `@${user.userName}`) : getUserDisplayName(user)).toUpperCase()}</p>
                    <p className='fg-black fw-medium mt-8 mb-0'>{getUserDisplayName(user)}</p>
                    {user?.address && <p className='fg-hyk-medgrey mt-8 mb-0'>{user.address}</p>}
                </div>
            </div>


            <div className='d-flex mx-16 aic mb-16 jcsa'>
                <div className='fs-xxs fg-grey'>{user?.subscribers_number || 0} subscribers</div>
                <div className='fs-xxs fg-grey'>{user?.nbContributors || 0} contributors</div>
            </div>
            <div className='px-16'>
                <button className='btn btn-outline-white-v2 btn-sm rounded-xl btn-full mb-8' onClick={handleCreateChat}>{loadingCreateChat ? <i className="fa fa-spin fa-spinner"></i> : 'Message'}</button>
                <button className='btn btn-outline-white-v2 btn-sm rounded-xl btn-full mb-24' onClick={() => setShowNetworks(true)}>View Networks</button>
            </div> */}
            { (<>
                <MenuProfile
                    menu_items={MENU_ITEMS}
                    selected={selected}
                    setSelected={setSelected}
                    user={user}
                    className='user-profile-menu'
                    extendedProps={{
                        creations: creations,
                        handleViewCreation,
                        news: user?.news || [],
                        viewuser_loading: viewuser_loading,
                        user: user
                    }}
                />
           </> )}
        </div>
    )
}

export default UserProfile